<template>
  <svg :width="width" :height="height" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="35" height="35" rx="17.5" fill="#B80909" fill-opacity="0.2" />
    <rect x="2.5" y="2.5" width="30" height="30" rx="15" fill="#D46B6B" fill-opacity="0.4" />
    <path
      d="M20.7398 8.2598L25.5398 13.0598M7.29981 16.8998H26.4998C26.4998 18.7985 25.9368 20.6546 24.8819 22.2333C23.8271 23.812 22.3277 25.0424 20.5736 25.769C18.8194 26.4956 16.8892 26.6858 15.0269 26.3153C13.1647 25.9449 11.4542 25.0306 10.1116 23.688C8.769 22.3454 7.85469 20.6349 7.48427 18.7727C7.11385 16.9105 7.30396 14.9802 8.03057 13.226C8.75717 11.4719 9.98762 9.97256 11.5663 8.9177C13.145 7.86283 15.0011 7.2998 16.8998 7.2998C14.4348 9.88811 13.0598 13.3255 13.0598 16.8998C13.0598 20.4741 14.4348 23.9115 16.8998 26.4998C19.3649 23.9115 20.7398 20.4741 20.7398 16.8998M25.5398 8.2598L20.7398 13.0598"
      stroke="#B80909"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ width?: string | number; height?: string | number }>(), {
  width: '35',
  height: '35',
});
</script>
